<div
  v-if="tile"
  class="card bcx-card mb-3"
  @mouseenter="is_hovered = true"
  @mouseleave="is_hovered = false"
>
  <div class="card-body p-4">

    <!-- Top Row -->
    <div class="d-flex justify-content-between align-items-start mb-3">

      <!-- Icon chip -->
      <div class="bcx-icon-chip">
        <i v-if="tile.icon" :class="tile.icon"></i>
        <i v-else class="bi bi-buildings"></i>
      </div>

      <!-- Stat -->
      <div class="fw-bold fs-5">
        {{ tile.stats }}
      </div>

    </div>

    <!-- Title -->
    <h5 class="card-title fw-bold mb-1">
      {{ tile.title }}
    </h5>

    <!-- Description + Trend on same row -->
    <div class="d-flex justify-content-between align-items-center mb-2">
      <span class="card-text text-xxs">
        {{ tile.description }}
      </span>

      <span class="text-success fw-semibold text-xxs ms-2">
        {{ tile.trend }}
      </span>
    </div>

    <!-- Button aligned right -->
    <div class="d-flex justify-content-end mt-3">
      <button
        class="btn btn-primary btn-sm rounded-pill fw-semibold text-xxs px-3"
        @click="handleTileClick(tile)"
      >
        {{ getButtonText() }}
      </button>
    </div>

  </div>
</div>
